// extracted by mini-css-extract-plugin
module.exports = {"container":"U_7IyQV7g4pc6QpvKEAXq","groupsList":"_2BRXMTffZ7O12BeacmxNNH"};